import { useEffect, useRef, useState } from 'react';
import { Formik, Form, Field, FieldArray, ErrorMessage, useFormikContext } from 'formik';
import { KeenIcon, DefaultTooltip, LazyFormikSelect, DatePicker, CustomOption, CustomSingleValue } from '@/components';
import { useLazyOptions } from '@/hooks';
import { toast } from 'sonner';
import itemService from '@/services/billing/itemService';
import expenseService from '@/services/billing/expenses/expenseService';
import userService from '@/services/setting/userService';
import taxService from '@/services/billing/taxService';
import invoiceService from '@/services/billing/invoice/invoiceService';
import { PriceInput } from '@/components/form';
import { calculateSubtotal } from '@/utils';
import { ItemsModal } from '@/pages/billing';
import { useAbility } from '@/providers/';
import { Can } from '@casl/react';
import { useUserOptions, useTaxOptions, useItemOptions } from '@/hooks'

const FlatFees = ({ openModal, loadOnChange }) => {
    const { values, setFieldValue } = useFormikContext();
    const [dataLoading, setDataLoading] = useState(false);
    const [userData, setuserData] = useState([]);
    const [itemData, setItemData] = useState([])
    const flatFeesSettings = values.template_Settings?.flat_fees
    const [open, setOpen] = useState(false);
    const formikRef = useRef();
    const [itemId, setItemId] = useState(null)
    const [selectedData, setSelectedData] = useState(null);
    const [mode, setMode] = useState('create');
    const [isLoading, setIsLoading] = useState(false)
    const [loading, setLoading] = useState(false)
    const [taxesData, setTaxesData] = useState([])
    const { ability } = useAbility();
    const loadUserOptions = useUserOptions({ defaultPageSize: 20 });
    const loadTaxOptions = useTaxOptions({ defaultPageSize: 20 });
    const loadItemOptions = useItemOptions({ defaultPageSize: 20 });

    const handleModalClose = () => {
        setItemId(null)
        setSelectedData(null)
        setMode('create')
        setOpen(false)
    }

    // useEffect(() => {
    //     resetItems();
    // }, [loadOnChange]);


    useEffect(() => {
        // console.log("Contact ID from Step 1:", values.contact_id);
        // You can also use it for fetching related data
    }, [values.contact_id]);

    return (
        <>
            <div className='flex items-center my-5'>
                <span className='w-1/2 h-0.5 border border-dashed inline-block'></span>
                <p className='text-sm flex shrink-0  mx-4 w-fit'>Flat Fees</p>
                <span className='w-1/2 h-0.5 border border-dashed inline-block'></span>
            </div>
            <div>
                <FieldArray name="flat_fees" className="card">
                    {({ push, remove }) => (
                        <>
                            {values.flat_fees.map((_, index) => (
                                <div key={index} className=''>
                                    <div className='flex items-center justify-between mb-3'>
                                        <div className='flex items-center'>
                                            <span className='w-12 h-0.5 bg-border inline-block mr-2'></span>
                                            <h4 className='text-sm'>Flat Fees #{index + 1}</h4>
                                        </div>
                                        <div className='flex items-center gap-1.5'>
                                            {/* {index === 0 && values.expenses.length < 10 && (
                                        <button type="button" className='text-xs btn btn-sm btn-light' onClick={() => push({
                                            item_id: '',
                                            flat_fee: null,
                                            description: '',
                                            billed_by: '',
                                            billed_by_user: null,
                                            quantity: 1,
                                            rate: '',
                                            date: new Date().toISOString().split('T')[0],
                                            tax: [],
                                        })}>
                                            <KeenIcon icon="plus" />
                                            Add Flat Fee
                                        </button>
                                    )} */}
                                            <button type="button" className='btn btn-sm btn-danger btn-outline my-2' onClick={() => remove(index)}>
                                                <KeenIcon icon="trash" />
                                                Remove
                                            </button>
                                            {/* {values.flat_fees.length > 1 && (
                                    )} */}
                                        </div>
                                    </div>

                                    <div className="rounded-md p-1.5 flex flex-nowrap">
                                        <div className='invoice-select-w'>
                                            <label className="form-label mb-1.5 pl-1.5">{flatFeesSettings?.flat_fees_label || 'Flat Fees'} </label>
                                            <LazyFormikSelect
                                                name={`flat_fees[${index}].item_id`}
                                                loadOptions={loadItemOptions}
                                                pageSize={20}
                                                preloadedOption={values.flat_fees[index].flat_fee}
                                                transparent={true}
                                                noOptionsMessage={() => (
                                                    isLoading ? (
                                                        <span className="text-sm">Loading...</span>
                                                    ) : (
                                                        <div>
                                                            <span className="text-sm mr-1">No options available</span>
                                                            <Can I='create' a='item' ability={ability}>
                                                                <button type="button"
                                                                    onClick={openModal}
                                                                    className="link block mx-auto"
                                                                >
                                                                    Add new
                                                                </button>
                                                            </Can>
                                                        </div>
                                                    )
                                                )}
                                                onOptionSelect={(selected) => {
                                                    console.log('selected', selected)
                                                    if (selected?.id) {
                                                        // The seeded items are priced 0.00; leave the rate blank instead of $0.00 (OL-184).
                                                        const isValidRate = Number(selected?.price) > 0 ? selected.price : '';
                                                        setFieldValue(`flat_fees[${index}].rate`, isValidRate);
                                                    }
                                                }}
                                            // customClassNames={{
                                            //     menuList: '!max-h-[120px]',
                                            // }}
                                            />
                                            <ErrorMessage
                                                name={`flat_fees[${index}].item_id`}
                                                component="div"
                                                className="text-red-500 text-[11px] mt-1"
                                            />
                                        </div>
                                        <div className='invoice-date-w'>
                                            <label className="form-label mb-1.5 pl-1.5">{flatFeesSettings?.date_label || 'Date'}</label>
                                            <Field name={`flat_fees[${index}].date`} component={DatePicker} isRange={false} transparent={true} />
                                            <ErrorMessage
                                                name={`flat_fees[${index}].date`}
                                                component="div"
                                                className="text-red-500 text-[11px] mt-1"
                                            />
                                        </div>
                                        <div className='invoice-date-w'>
                                            <label className="form-label mb-1.5 pl-1.5">To</label>
                                            <Field name={`flat_fees[${index}].date_to`} component={DatePicker} isRange={false} transparent={true} />
                                            <ErrorMessage name={`flat_fees[${index}].date_to`} component="div" className="text-red-500 text-[11px] mt-1" />
                                        </div>
                                        <div className='invoice-select-w'>
                                            <label className="form-label mb-1.5 pl-1.5">{flatFeesSettings?.billed_by_label || 'Billed By'}</label>
                                            <LazyFormikSelect
                                                name={`flat_fees[${index}].billed_by`}
                                                loadOptions={loadUserOptions}
                                                pageSize={20}
                                                preloadedOption={values.flat_fees[index].billed_by_user}
                                                transparent={true}
                                                components={{
                                                    Option: CustomOption,
                                                    SingleValue: CustomSingleValue,
                                                }}
                                            />
                                            <ErrorMessage
                                                name={`flat_fees[${index}].billed_by`}
                                                component="div"
                                                className="text-red-500 text-[11px] mt-1"
                                            />
                                        </div>
                                        <div className='invoice-price-w'>
                                            <label className="form-label mb-1.5 pl-1.5">{flatFeesSettings?.quantity_label || 'Quantity'}</label>

                                            <Field name={`flat_fees[${index}].quantity`}>
                                                {({ field, form }) => (
                                                    <input
                                                        {...field}
                                                        type="number"
                                                        className="input transparent-input no-spinner"
                                                        step={'1'}
                                                        min="0"
                                                        inputMode={'numeric'}
                                                        onChange={(e) => {
                                                            let value = e.target.value;
                                                            value = value.replace(/\D/g, '');
                                                            value = value.replace(/^0+(?!$)/, '');
                                                            form.setFieldValue(`flat_fees[${index}].quantity`, value);
                                                        }}
                                                    />
                                                )}
                                            </Field>
                                            <ErrorMessage
                                                name={`flat_fees[${index}].quantity`}
                                                component="div"
                                                className="text-red-500 text-[11px] mt-1"
                                            />
                                        </div>
                                        <div className='invoice-rate-w shrink-0 overflow-x-hidden'>
                                            <label className="form-label mb-1.5 pl-1.5">{flatFeesSettings?.price_label || 'Price'}</label>
                                            <PriceInput name={`flat_fees[${index}].rate`} prefix="$" allowDecimal={false} className="transparent-input" />
                                        </div>
                                        <div className='invoice-rate-w'>
                                            <label className="form-label mb-1.5 pl-1.5">{flatFeesSettings?.subtotal_label || 'Sub'}</label>
                                            <div className='input transparent-input'>
                                                {calculateSubtotal(values.flat_fees[index].rate, values.flat_fees[index].quantity)}
                                            </div>
                                        </div>
                                        <div className='invoice-tax-w !w-[230px]'>
                                            <label className="form-label mb-1.5 pl-1.5">{flatFeesSettings?.tax_label || 'Tax'}</label>
                                            <LazyFormikSelect
                                                name={`flat_fees[${index}].tax`}
                                                loadOptions={loadTaxOptions}
                                                isMulti={true}
                                                preloadedOption={values.flat_fees[index].taxes?.length > 0 ? values.flat_fees[index].taxes : []}
                                                transparent={true}
                                                returnFullObject
                                            // customClassNames={{
                                            //     menuList: '!max-h-[120px]',
                                            // }}
                                            />
                                            <ErrorMessage
                                                name={`flat_fees[${index}].tax`}
                                                component="div"
                                                className="text-red-500 text-[11px] mt-1"
                                            />
                                        </div>
                                        <div className='invoice-description-w'>
                                            <label className="form-label mb-1.5 pl-1.5">{flatFeesSettings?.description_label || 'Description'}</label>
                                            <Field as="textarea" className="input transparent-input pt-2 overflow-auto custom-scrollbar" name={`flat_fees[${index}].description`} />
                                            <ErrorMessage
                                                name={`flat_fees[${index}].description`}
                                                component="div"
                                                className="text-red-500 text-[11px] mt-1"
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {/* No row limit (OL-200). The button sits under the last row, so a new row opens where the user is. */}
                            <div className='flex items-center justify-end'>
                                <button
                                    type="button"
                                    className='text-xs btn btn-sm btn-light'
                                    onClick={() =>
                                        push({
                                            item_id: '',
                                            flat_fee: null,
                                            description: '',
                                            billed_by: '',
                                            billed_by_user: null,
                                            quantity: null,
                                            rate: '',
                                            date: '', //new Date().toISOString().split('T')[0]
                                            tax: [],
                                        })
                                    }
                                >
                                    <KeenIcon icon="plus" />
                                    Add Flat Fee
                                </button>
                            </div>
                        </>
                    )}
                </FieldArray>
            </div>
        </>
    )
}

export { FlatFees }